import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/NewsletterSubscription/newsletterSubscription.container"
    ).then((module) => ({
        default: module.NewsletterSubscription
    }))
);
